<template>
  <div id="sales" v-if="divVisible">
    <b>管理人月数情報一覧画面</b><br/><br/>

    <table>
      <tr>
        <td>管理人月数を参照いただきます。  <B style="color:red;">略称の説明 ： L=リーダー、M=メンバー、H=ヘルパー </B></td>
      </tr>
    </table><br/>

    <form onsubmit="return false;">
      <div class="bootstrap-table fixed-table-container" style="margin-bottom:10px;width: 250%;">
        <table id="rptHeader" class="table table-striped">
          <thead>
            <tr v-for="(head, index) in heads" v-bind:key="'head' + index">
              <td style="position: sticky;top: 0;width: 7%;background: white; " v-for="(headCell, index2) in head.cells" v-bind:key="'headCell' + index2">
                  {{ headCell.info.headTitle }}
              </td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, index) in rows" v-bind:key="'row' + index">
              <template   v-for="(rowCell, index2) in row.cells" >
              
              <td style="position: sticky;left: 0;background: white; white-space: nowrap;"  v-if="index2==0" v-bind:key="'rowCell' + index2">    
                    <h4>{{ rowCell.info.leaderMemberName }}</h4><br/> 
                    管理人月数：<br/>   
                    &nbsp;上期：{{rowCell.info.managementPointFirstHalf}}<br/>   
                    &nbsp;下期：{{rowCell.info.managementPointSecondHalf}}<br/>   
                    &nbsp;<B>合計：{{rowCell.info.managementPoint}}</B>
                </td>
                <td v-else v-bind:key="'rowCell' + index2">
                  <div v-for="(rowCellItem, index3) in rowCell.items" v-bind:key="'rowCellItem' + index3">
                    <template v-if="user.userType == '5'">
                        {{ rowCellItem.projectInfo.projectName }}
                    </template>
                    <template v-else>
                      <router-link :to="{ name: 'projectDetails', params: { backScreenId: 'sales', year: rowCellItem.year, projectID: rowCellItem.projectInfo.projectID } }">
                        {{ rowCellItem.projectInfo.projectName }}
                      </router-link> 
                    </template><br/>
                    <span v-if="rowCellItem.allLeaderMemberName">         
                    &nbsp;&nbsp;&nbsp;L:{{ rowCellItem.allLeaderMemberName }}<br/>
                    </span> 
                    <span v-if="rowCellItem.allGeneralMemberName">   
                    &nbsp;&nbsp;&nbsp;M:{{ rowCellItem.allGeneralMemberName }}<br/>
                    </span> 
                    <span v-if="rowCellItem.allHelperMemberName">   
                    &nbsp;&nbsp;&nbsp;H:{{ rowCellItem.allHelperMemberName }}<br/>
                    </span>
                    <br/>
                  </div>
                  <br/>
                  <div v-if="rowCell.info.comment" >

                    <template v-if="user.userType == '5'">
                        <b>コメント：</b><br>
                    </template>
                    <template v-else>
                        <router-link  :to="{ name: 'managementPointEdit', params: {  projects:rowCell.items , memberID:rowCell.info.leaderMemberID , memberName: rowCell.info.leaderMemberName ,yearMonth:  rowCell.info.yearMonth } }">
                          <b>コメント：</b><br>
                        </router-link>
                    </template>
                    <textarea style="border: none;height:100px"   readonly v-model="rowCell.info.comment"/>
                      
                  </div>
                    <template v-if="user.userType == '5'">
                      <b>管理人月数：</b>
                    </template>
                    <template v-else>
                      <router-link :to="{ name: 'managementPointEdit', params: {   projects:rowCell.items , memberID:rowCell.info.leaderMemberID , memberName: rowCell.info.leaderMemberName ,yearMonth:  rowCell.info.yearMonth } }">
                      <b>管理人月数：</b> </router-link>                       
                    </template>
                    {{rowCell.info.managementPoint}}

                </td>
              </template >
            </tr>
          </tbody>
        </table>
      </div><br/>
      <button @click="$router.push({ name: 'mains', params: { } });" class="btn-mid" style="width:250px;">メイン画面へ</button><br/>
    </form>
  </div>
</template>

<script>
  export default {
    name: "sales",
    data() {
      return {
          divVisible: false,
          user:  { memberID: '', memberName: '', userType: '', deleteFlg: '' },
          heads: null,
          rows:  null,
 
      }
    },
    mounted() {
      const s = document.createElement('script');
      s.type = 'text/javascript';
      s.src = '/static/js/common.js?v=17';
      document.body.appendChild(s);
      this.init();
    },
    methods: {
      init: function () {
        var self = this;

        // サーバ側処理呼び出す
        new Promise(function (request, response) {
          var data = self.$route.params;
          common.getAxios().post(process.env.API_URL +"/api/SalesInit", data)
            .then(function (res) {
              if (res.data) {
                self.user = res.data.user;
                self.heads = res.data.heads;
                self.rows = res.data.rows;
                self.divVisible = true;
              }
            })
            .catch(function (err) {
              alert(err);
            });
        });

      },
    }

  };
</script>



// WEBPACK FOOTER //
// sales.vue?cdb24144